import { computed, IComputedValue } from 'mobx';
import { getPackageBaseUrl } from 'owa-config';
import { resolve as urlResolve } from 'url';
import getStore from '../store/store';
import { isFolderPaused } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

const FAVICON_RELATIVE_PATH = 'resources/images/favicons';
const MAIL_SEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-seen.ico`;
const MAIL_UNSEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-unseen.ico`;

export default computed(function mailFaviconProvider(): string {
    if (getStore().unseenMessages === 0 || isFolderPaused(folderNameToId('inbox'))) {
        return getIconPath(MAIL_SEEN_FAVICON);
    } else {
        return getIconPath(MAIL_UNSEEN_FAVICON);
    }
});

export { IComputedValue };

function getIconPath(relativeUrl: string): string {
    return urlResolve(getPackageBaseUrl(), relativeUrl);
}
